import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { LabelModeEnum, LabelTypeEnum } from '@frontend-site/ui/components';
import { StatusRendererOption, StatusRendererParams } from './status-renderer.model';

@Component({
    selector: 'entity-status-renderer',
    template: `
        <p-field-entity-status
            [mode]="LabelModeEnum.GridMode"
            class="entity-status"
            [value]="value"
            [statusTranslatePrefix]="statusTranslatePrefix"
            [statusColors]="statusColors"
            [isDisabled]="true"
            [automationIdSuffix]="'renderer'"
            [list]="statusList"
        ></p-field-entity-status>
    `,
    styleUrls: ['./status-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusRendererComponent<TData> implements ICellRendererAngularComp {
    public value = '';
    public statusTranslatePrefix = '';
    public statusColors!: Record<string, LabelTypeEnum>;
    public statusList: StatusRendererOption[] = [];

    constructor(private cd: ChangeDetectorRef) {}

    public agInit(params: StatusRendererParams<TData>): void {
        this.init(params);
    }

    public refresh(params: StatusRendererParams<TData>): boolean {
        this.init(params);
        this.cd.detectChanges();
        return true;
    }

    private init(params: StatusRendererParams<TData>): void {
        this.value = params.value;
        this.statusTranslatePrefix = params.statusTranslatePrefix;
        this.statusList = params.statusList;
        this.statusColors = typeof params.statusColors === 'function' ? params.statusColors(params.node.data) : params.statusColors;
    }

    protected readonly LabelModeEnum = LabelModeEnum;
}
